import { HeaderProvider } from 'header'
import PropTypes from 'prop-types'
import StateProvider from '~workspace/states/provider'
import { Workspace } from './Workspace'

const App = (props) => {
  return (
    <HeaderProvider>
      <StateProvider initialState={props}>
        <Workspace workspaceId={props.workspaceId} />
      </StateProvider>
    </HeaderProvider>
  )
}

App.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.string.isRequired
}

export { App }
